import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getRequestConfig } from "../logic/supportFunctions"
import { fetchSurrogateUserList } from "./applicationParametersSlice"
import * as con from '../../GlobalConstants'
import axios from "axios"
import { buildSurrogateUserTransactionsDict } from "../../GlobalFunctions"
import { createError } from "../../templates/notifications/Notifications"
import { extractErrorMessage } from "../../utils/errorFunctions"


export const fetchAllSurrogateTransactionsByType = createAsyncThunk(
  'surrogateUserTransaction/fetchByType',
  async ({ api, transactionType }, { rejectWithValue }) => {
    try {
      const config = getRequestConfig()
      const res = await axios.get(con.rest_base_url + api, config)
      let value = res.data
      return { transactionType, value }
    } catch (err) {
      return rejectWithValue({ transactionType, error: extractErrorMessage(err, "Error cargando transacciones") })
    }
  }
)

export const fetchAllSurrogateTransactions = createAsyncThunk(
  'surrogateUserTransaction/fetchAll',
  async (_, { dispatch }) => {
    
    const result = await dispatch(fetchSurrogateUserList())
    
    if (fetchSurrogateUserList.fulfilled.match(result)) {
      dispatch(initSurrogateStructure(result.payload))
    }

    const types = [
      { api: con.transactions_api + con.all_surrogate_user_model_parameters_api,   transactionType: con.MODEL_PARAMETERS },
      { api: con.transactions_api + con.all_surrogate_user_exposures_api,           transactionType: con.EXPOSURES },
      { api: con.transactions_api + con.all_surrogate_user_coverages_fwd_api,       transactionType: con.COVERAGES_FWD },
      { api: con.transactions_api + con.all_surrogate_user_coverages_spot_api,      transactionType: con.COVERAGES_SPOT },
      { api: con.transactions_api + con.all_surrogate_user_coverages_option_api,    transactionType: con.COVERAGES_OPTION },
      { api: con.transactions_api + con.all_surrogate_user_accounts_api,            transactionType: con.ACCOUNTS },
    ]

    types.forEach(args => dispatch(fetchAllSurrogateTransactionsByType(args)))
  }
)

// =========================
// SLICE
// =========================

const initialState = {
    [con.REDUCER_SURROGATE_USERS_TRANSACTIONS]: {},
    [con.SURROGATE_TRANSACTIONS_LOADED]: {
      [con.EXPOSURES]: con.NOT_STARTED,
      [con.COVERAGES_FWD]: con.NOT_STARTED,
      [con.COVERAGES_SPOT]: con.NOT_STARTED,
      [con.COVERAGES_OPTION]: con.NOT_STARTED,
      [con.ACCOUNTS]: con.NOT_STARTED,
      [con.MODEL_PARAMETERS]: con.NOT_STARTED,
      [con.COMMENTS]: con.NOT_STARTED,
    }
}
const surrogateUserTransactionsSlice = createSlice({
  name: con.REDUCER_SURROGATE_USERS_TRANSACTIONS,
  initialState,
  reducers: {

    initSurrogateStructure: (state, action) => {
      state[con.REDUCER_SURROGATE_USERS_TRANSACTIONS] = 
        buildSurrogateUserTransactionsDict(action.payload)
      
      // Reset status
      Object.keys(state[con.SURROGATE_TRANSACTIONS_LOADED]).forEach(type => {
        state[con.SURROGATE_TRANSACTIONS_LOADED][type] = con.NOT_STARTED
      })
    }

  },
  extraReducers: (builder) => {
    builder

      // ── fetchByType ──────────────────────────────────────
      .addCase(fetchAllSurrogateTransactionsByType.pending, (state, action) => {
        const { transactionType } = action.meta.arg
        state[con.SURROGATE_TRANSACTIONS_LOADED][transactionType] = con.LOADING
      })

      .addCase(fetchAllSurrogateTransactionsByType.fulfilled, (state, action) => {
        const { transactionType, value: transactionArray } = action.payload

        if (transactionType === con.MODEL_PARAMETERS) {
          transactionArray.forEach(trans => {
            state[con.REDUCER_SURROGATE_USERS_TRANSACTIONS][trans[con.USER]]
                                                          [trans[con.USER_LINE]]
                                                          [transactionType] = trans
          })
        } else if (transactionType === con.COMMENTS) {
          transactionArray.forEach(comm => {
            state[con.REDUCER_SURROGATE_USERS_TRANSACTIONS][comm[con.USER]]
                                                          [comm[con.USER_LINE]]
                                                          [transactionType]
                                                          .push(comm)
          })
        } else {
          transactionArray.forEach(trans => {
            state[con.REDUCER_SURROGATE_USERS_TRANSACTIONS][trans[con.USER]]
                                                          [trans[con.USER_LINE]]
                                                          [transactionType]
                                                          [trans[con.ID]] = trans
          })
        }

        state[con.SURROGATE_TRANSACTIONS_LOADED][transactionType] = con.OK
      })

      .addCase(fetchAllSurrogateTransactionsByType.rejected, (state, action) => {
        const { transactionType } = action.meta.arg
        state[con.SURROGATE_TRANSACTIONS_LOADED][transactionType] = con.ERROR
        createError(action.payload.error);
      })

  },
})

export const { initSurrogateStructure } = surrogateUserTransactionsSlice.actions
export default surrogateUserTransactionsSlice.reducer